<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex md12>

        <v-stepper v-model="e1" vertical class="white elevation-8 stepper-customized pb-0">

          <v-stepper-step step="1" class="w-100" :editable="e1 > 1">
            <v-layout justify-center align-center class="w-100">
              <v-flex :class="{'f1-2em text-light':true, 'md7':e1 == 1, 'md7':e1 > 1}">
                <v-layout row wrap>
                  <v-flex md12 class="f1-5em" :class="{'black--text':e1 == '1'}">
                    Gestiones a reenviar
                  </v-flex>
                  <v-flex md12 class="f0-8em grey--text">
                    {{e1 == '1' ? campaign.name : ''}}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex md5 class="k-orange-linear-text f1-5em text-light text-xs-right pr-3" v-if="e1 > 1">
                Completado <v-icon class="k-orange-linear-text pl-2">fas fa-check</v-icon>
              </v-flex>
            </v-layout>
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-card class="transparent">
              <vue-perfect-scrollbar class="confirm-campaign--scrollbar">
                <v-card-text class="white pt-3 pr-3 pb-0 pl-5">
                  <v-list class="pl-5">
                    <v-list-tile v-for="(status, i) in statusOfNotificationSchedules" :key="i">
                      <v-layout align-center justify-center>
                        <v-flex md2 text-xs-right mr-3>
                          <v-icon small class="k-orange-linear-text">fa-{{icons[status.status]}}</v-icon>
                        </v-flex>
                        <v-flex md6 class="f1-1em">
                          {{status.status}}: <span class="k-grey-text f0-8em">{{status.total}}</span>
                        </v-flex>
                        <v-flex md4 text-xs-center>
                          <v-checkbox v-model="selectedStatusOfNotificationSchedules" class="k-orange-linear-text mt-4 pa-0 ml-4 pl-3" :value="status.value"></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </v-list-tile>
                  </v-list>
                  <!-- <template v-else>
                    <v-layout justify-center align-center fill-height>
                      <v-flex md12 class="headline k-grey-light-text text-xs-center">
                        <img src="../../assets/img/loader.gif" width="100px"/>
                      </v-flex>
                    </v-layout>
                  </template> -->
                </v-card-text>
              </vue-perfect-scrollbar>
              <v-card-actions class="white px-0 mr-2">
                <v-layout row wrap class="px-0">
                  <v-flex md12 text-xs-right>
                    <v-btn flat color="black" large @click="$router.push('/campaigns')">CANCELAR</v-btn>
                    <v-btn class="k-orange-linear white--text elevation-1" large @click="getCustomersStatus" :disabled="selectedStatusOfNotificationSchedules.length === 0">SIGUIENTE</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
          <v-stepper-step step="2" class="w-100" :editable="e1 > 2">
            <v-layout justify-center align-center class="w-100">
              <v-flex :class="{'f1-2em text-light':true, 'md7':e1 == 2, 'md7':e1 > 2}">
                <v-layout row wrap>
                  <v-flex md12 class="f1-5em" :class="{'black--text':e1 == '2'}">
                    Clientes a reenviar
                  </v-flex>
                  <v-flex md12 class="f0-8em grey--text">
                    {{e1 == '2' ? campaign.name : ''}}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex md5 class="k-orange-linear-text f1-5em text-light text-xs-right pr-3" v-if="e1 > 2">
                Completado <v-icon class="k-orange-linear-text pl-2">fas fa-check</v-icon>
              </v-flex>
            </v-layout>
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-card class="transparent">
              <vue-perfect-scrollbar class="confirm-campaign--scrollbar">
                <v-card-text class="white pt-3 pr-3 pb-0 pl-5">
                  <v-list class="pl-5">
                    <v-list-tile v-for="(status, i) in statusOfCustomers" :key="i">
                      <v-layout align-center justify-center>
                        <v-flex md2 text-xs-right mr-3>
                          <v-icon small class="k-orange-linear-text">fa-{{icons[getCustomerStatus(status.customer_status_id)]}}</v-icon>
                        </v-flex>
                        <v-flex md6 class="f1-1em">
                          {{getCustomerStatus(status.customer_status_id)}}: <span class="k-grey-text f0-8em">{{status.total}}</span>
                        </v-flex>
                        <v-flex md4 text-xs-center>
                          <v-checkbox v-model="selectedStatusOfCustomers" class="k-orange-linear-text mt-4 pa-0 ml-4 pl-3" :value="status.customer_status_id"></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </v-list-tile>
                  </v-list>
                  <!-- <template v-else>
                    <v-layout justify-center align-center fill-height>
                      <v-flex md12 class="headline k-grey-light-text text-xs-center">
                        <img src="../../assets/img/loader.gif" width="100px"/>
                      </v-flex>
                    </v-layout>
                  </template> -->
                </v-card-text>
              </vue-perfect-scrollbar>
              <v-card-actions class="white px-0 mr-2">
                <v-layout row wrap class="px-0">
                  <v-flex md12 text-xs-right>
                    <v-btn flat color="black" large @click="$router.push('/campaigns')">CANCELAR</v-btn>
                    <v-btn class="k-orange-linear white--text elevation-1" large @click="searchTemplates" :disabled="selectedStatusOfCustomers.length === 0">SIGUIENTE</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
          <v-stepper-step step="3" class="w-100" :editable="e1 > 3">
            <v-layout justify-center align-center class="w-100">
              <v-flex :class="{'f1-2em text-light':true, 'md7':e1 == 3, 'md7':e1 > 3}">
                <v-layout row wrap>
                  <v-flex md12 class="f1-5em" :class="{'black--text':e1 == '3'}">
                    Plantilla
                  </v-flex>
                  <v-flex md12 class="f0-8em grey--text">
                    {{e1 == '3' ? campaign.name : ''}}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex md5 class="k-orange-linear-text f1-5em text-light text-xs-right pr-3" v-if="e1 > 3">
                Completado <v-icon class="k-orange-linear-text pl-2">fas fa-check</v-icon>
              </v-flex>
              <v-flex md5 pl-2 v-if="e1 == '3'">
                <v-select
                v-model="template"
                :items="templates"
                item-text="name"
                return-object
                v-validate="'required'"
                data-vv-name="template_id"
                data-vv-as="plantilla"
                :error-messages="errors.collect('template_id')"
                label="Plantilla de campaña"
                class="a-borders elevation-0"
                color="grey"
                solo>
                </v-select>
              </v-flex>
            </v-layout>
          </v-stepper-step>
          <v-stepper-content step="3">
            <v-card class="transparent" v-if="(campaign.channel === 'email' || campaign.channel === 'bot') && (template.status === 'Activo' || template.status === 'activo')">
              <v-card-text class="white">
                <vue-editor v-model="text" useCustomImageHandler @imageAdded="handleImageAdded" :editorToolbar="editorToolbar" v-if="campaign.channel === 'email'"></vue-editor>
                <p v-if="campaign.channel === 'bot'" class="text-xs-center f1-2em my-3">Si desea enviar la campaña con la plantilla de bot {{template.name}} de click a continuar.</p>
              </v-card-text>
              <v-card-actions class="white px-0 mr-2">
                <v-layout row wrap class="px-0">
                  <v-flex md12 text-xs-right>
                    <v-btn flat large @click="$router.push('/campaigns')">CANCELAR</v-btn>
                    <v-btn class="k-orange-linear white--text" large @click="campaign.channel === 'bot' ? e1 = e1 += 1 : updateTemplate(campaign.channel, template)">SIGUIENTE</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
            <v-card :height="'300px'" v-else-if="(campaign.channel !== 'email' && campaign.channel !== 'bot')">
              <v-card-text class="white">
                <textarea
                  v-model="text"
                  v-validate="`required|max:${campaign.channel === 'sms' ? '160' : '10000'}`"
                  data-vv-name="text"
                  data-vv-as="texto"
                  placeholder="Texto"
                  :class="{awesomplete: true, 'has-error': errors.has('text') || (textLength > 160 && campaign.channel === 'sms'), 'campaign': true}"
                  data-multiple
                  spellcheck="false">
                </textarea>
                <small class="custom-error" id="text-error" v-if="errors.has('text')">
                  {{ errors.first('text') }}
                </small>
                <small class="custom-error" v-if="campaign.channel === 'sms' && !errors.has('text') && textLength < 160">
                  160 / {{ textLength }}
                </small>
                <small class="custom-error" :id="textLength > 160 ? 'text-error' : ''" v-if="campaign.channel === 'sms' && !errors.has('text') && textLength > 160">
                  El texto no debe ser mayor a 160 caracteres, cada variable suma 10 caracteres al texto
                </small>
              </v-card-text>
              <v-card-actions class="white px-0 mr-2 custom-actions">
                <v-layout row wrap class="px-0">
                  <v-flex md12 text-xs-right>
                    <v-btn flat large @click="$router.push('/campaigns')">CANCELAR</v-btn>
                    <v-btn class="k-orange-linear white--text" large @click="updateTemplate(campaign.channel, template)">SIGUIENTE</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
          <v-stepper-step step="4" class="w-100">
            <v-layout justify-center align-center class="w-100">
              <v-flex :class="{'f1-2em text-light md12':true}">
                <v-layout row wrap>
                  <v-flex md12 class="f1-5em" :class="{'black--text':e1 == '4'}">
                    Información de campaña
                  </v-flex>
                  <v-flex md12 class="f0-8em grey--text">
                    {{e1 == '4' ? campaign.name : ''}}
                  </v-flex>
                </v-layout>
              </v-flex>
              <!-- <v-flex md4 v-if="e1 == '3'">
                <v-select
                  :items="deliveryOptions"
                  v-model="form.delivery_option"
                  color="grey"
                  item-text="name"
                  item-value="value"
                  class="a-borders elevation-0"
                  label=""
                  solo
                ></v-select>
              </v-flex> -->
            </v-layout>
          </v-stepper-step>
          <v-stepper-content step="4">
            <v-card class="transparent">
              <v-card-text class="white pt-3 pr-3 pb-3 pl-0 elevation-0">
                <v-layout row wrap>
                  <v-flex md6 px-4>
                    <v-layout row wrap>
                      <v-flex md12 px-4>
                        <v-text-field
                          color="grey"
                          label="Nombre de campaña"
                          v-model="form.name"
                          v-validate="'required|max:100'"
                          data-vv-name="name"
                          data-vv-as="nombre"
                          :error-messages="errors.collect('name')"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md12 px-1 v-for="option in deliveryOptions" :key="`${option.value}_option`">
                        <v-btn block round :disabled="option.disabled" large :outline="option.value !== form.delivery_option" :class="{'k-orange-linear white--text':option.value === form.delivery_option, 'k-orange-linear-underline k-orange-linear-text elevation-0':option.value !== form.delivery_option}" @click="form.delivery_option = option.value">
                          <v-icon small class="pr-2">{{option.icon}}</v-icon> {{option.name}}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md12>
                        <div class="accordion-content">
                          <v-divider v-if="form.delivery_option === 'Agendada'" class="white"></v-divider>
                          <v-layout row wrap :class="{'content':true, 'open':form.delivery_option === 'Agendada', 'close':form.delivery_option !== 'Agendada'}">
                            <v-flex md6 pr-2>
                              <v-menu
                                ref="date"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="form.start_date"
                                transition="scale-transition"
                                min-width="290px"
                                lazy
                                offset-y
                                full-width>
                                <v-text-field
                                  slot="activator"
                                  v-model="formatedStartDate"
                                  color="grey"
                                  append-icon="event"
                                  label="Inicio de campaña"
                                  readonly>
                                </v-text-field>
                                <v-date-picker
                                  v-model="form.start_date"
                                  @input="$refs.date.save(form.start_date)"
                                  locale="es"
                                  color="k-orange-linear">
                                </v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex md6 pl-2>
                              <v-menu
                                ref="time"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="form.start_hour"
                                transition="scale-transition"
                                min-width="290px"
                                lazy
                                offset-y
                                full-width>
                                <v-text-field
                                  slot="activator"
                                  v-model="formatedStartHour"
                                  color="grey"
                                  append-icon="fas fa-clock"
                                  label="Horario de inicio"
                                  readonly>
                                </v-text-field>
                                <v-time-picker
                                  v-model="form.start_hour"
                                  @input="$refs.time.save(form.start_hour)"
                                  locale="es"
                                  color="k-orange-linear">
                                </v-time-picker>
                              </v-menu>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex md6>
                    <div class="a-borders">
                      <v-layout justify-center align-center pl-4>
                        <v-flex md3 class="top-4 k-orange-linear text-xs-center pb-5 pt-5">
                          <v-icon class="white--text" large>fas fa-flag</v-icon>
                        </v-flex>
                        <v-flex md9>
                          <v-layout justify-start align-center px-3 pt-2>
                            <v-flex md12>
                              <v-layout row wrap>
                                <v-flex md12 class="f1-2em">
                                  {{campaign ? campaign.name : ''}}
                                </v-flex>
                                <v-flex md12 class="f0-9em k-grey-text">
                                  {{template.status === 'activo' ? template.name : ''}}
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center align-center pb-2 pt-2 pl-3>
                            <v-flex md12>
                              <v-layout row wrap>
                                <v-flex md12 class="f1-1em">
                                  Fecha de incio
                                </v-flex>
                                <v-flex md12 class="f0-9em k-grey-text">
                                  {{campaign.delivery_option ? campaign.delivery_option === 'Inmediata' ? formatDate(new Date(), 'YYYY-MM-DD', 'DD/MM/YYYY') : formatDate(form.start_date ? form.start_date : new Date(), 'YYYY-MM-DD', 'DD/MM/YYYY') : formatDate(new Date(), 'YYYY-MM-DD', 'DD/MM/YYYY') }}
                                  {{campaign.delivery_option ? campaign.delivery_option === 'Inmediata' ? formatDate(new Date(), 'h:mm a', 'h:mm A') : formatDate(form.start_hour ? form.start_hour : new Date(), 'H:mm a', 'h:mm A') : formatDate(new Date(), 'h:mm a', 'h:mm A') }}
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions class="white px-0 pb-4 mr-5">
                <v-layout row wrap class="px-0">
                  <v-flex md12 text-xs-right>
                    <v-btn flat color="black" large @click="$router.push('/campaigns')">CANCELAR</v-btn>
                    <v-btn class="k-orange-linear white--text" large @click="confirmDeliveryOption" :disabled="errors.any()">SIGUIENTE</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

        </v-stepper>

      </v-flex>
    </v-layout>
    <!-- <v-dialog
      v-model="alertDialog"
      max-width="400px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-text>
          <v-layout justify-center align-center py-2>
            <v-flex md3 text-xs-center>
              <v-icon class="red--text">fas fa-info-circle</v-icon>
            </v-flex>
            <v-flex md9 class="red--text">
              {{text}}
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog> -->
  </v-container>
</template>

<script>
import Vue from 'vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import EventBus from '@/event-bus';
import moment from 'moment';
import DataTable from '@/components/global/DataTable';
import campaignVarLists from '@/components/campaign_var/CampaignVarList';
import { VueEditor } from 'vue2-editor';
import emailEditorToolbarMixin from '@/mixins/emailEditorToolbar';
import { mapGetters } from 'vuex';

Vue.component('campaignVarLists', campaignVarLists);

export default {
  inject: ['$validator'],
  mixins: [
    emailEditorToolbarMixin,
  ],
  components: {
    DataTable,
    VuePerfectScrollbar,
    VueEditor,
  },
  created() {
    this.getCampaign();
    this.getCampaignStatus();
  },
  data() {
    return {
      e1: 1,
      text: '',
      status: {},
      campaign: {},
      template: {},
      templates: [],
      dialogTest: false,
      campaignVar: {},
      alertDialog: false,
      dialogOption: false,
      statusOfCustomers: [],
      selectedStatusOfCustomers: [],
      statusOfNotificationSchedules: [],
      selectedStatusOfNotificationSchedules: [],
      form: {
        to: '',
        name: '',
        delivery_option: 'Inmediata',
      },
      deliveryOptions: [
        {
          value: 'Inmediata',
          disabled: false,
          name: 'Inmediata',
          icon: 'fas fa-calendar-alt',
        },
      ],
      icons: {
        'En Proceso': 'clock',
        Ocupado: 'ban',
        Rechazado: 'bell-slash',
        'Buzon de Voz': 'user-times',
        'No contesta': 'user-clock',
        Programado: 'clipboard-check',
        'No entregado': 'comment-slash',
        Invalido: 'times',
        Error: 'times',
        Compromiso: 'calendar-check',
        Enviado: 'check',
        Leido: 'book-open',
        Entregado: 'user-check',
        Conectado: 'headset',
        Detenido: 'hand-paper',
        Equivocado: 'user-slash',
        'Sin compromiso': 'calendar-times',
        'Por eliminar': 'trash',
        Rebotado: 'voice_over_off',
        Incidencia: 'times',
        Gestionando: 'cogs',
        'Por gestionar': 'clock',
        Abono: 'hand-holding-usd',
        Contenido: 'inbox',
        Nulo: 'user-alt-slash',
      },
    };
  },
  computed: {
    ...mapGetters({
      customerStatusStore: 'customerStatus',
    }),
    formatedStartDate() {
      return this.form.start_date ? moment(this.form.start_date, 'YYYY-MM-DD').format('DD/MM/YYYY') : '';
    },
    formatedStartHour() {
      return this.form.start_date && this.form.start_hour ? moment(`${this.form.start_date} ${this.form.start_hour}:00`, 'YYYY-MM-DD H:mm A').format('h:mm A') : '';
    },
    textLength() {
      const vars = this.text.split('@').length - 1;
      const length = this.text.length + (vars * 10);
      return length;
    },
  },
  methods: {
    /* eslint-disable */
    getCustomerStatus(id) {
      return this.customerStatusStore(id).name;
    },
    formatedText(text) {
      if (text !== '') {
        let replace, variableText;
        Object.keys(this.campaignVar).forEach((key, i) => {
          variableText = `@${key === 'account' ? 'cuenta' : key === 'first_name' ? 'nombre' : key === 'last_name' ? 'apellido' : key === 'c_to' ? 'email' : key === 'agency' ? 'agencia' : key}`;
          variableText = new RegExp(variableText, 'g');
          if (i === 0) {
            replace = text.replace(variableText, `<span class="highlight-campaign-template">${this.campaignVar[key]}</span>`);
          } else if (key === 'var_2' && this.campaignVar[key]) {
            replace = replace.replace('@monto', `<span class="highlight-campaign-template">${this.campaign.channel === 'email' || this.campaign.channel === 'sms' ? `${new Intl.NumberFormat('es-VE').format(this.campaignVar[key])}` : `${Math.round(this.campaignVar[key])}`}</span>`);
          } else {
            replace = replace.replace(variableText, `<span class="highlight-campaign-template">${this.campaignVar[key]}</span>`);
          }
        });
        return replace;
      }
    },
    getCampaignStatus() {
      this.axios.get(`/notification_schedules/live_status?type_id=2&campaign=${this.$route.params.campaign}`).then((response) => {
        this.statusOfNotificationSchedules = response.data;
      });
    },
    getCustomersStatus() {
      this.axios.get(`/customers/status?campaign_id=${this.$route.params.campaign}&notifications_status=${this.selectedStatusOfNotificationSchedules.toString()}`).then((response) => {
        this.statusOfCustomers = response.data.contact;
        this.e1 = 2;
      });
    },
    getCampaign(number = null) {
      if (number != null) {
        this.e1 = number;
      }
      /* eslint-disable */
      this.axios.get(`/campaigns/${this.$route.params.campaign}?fields=channel,template_id,name,start_date,delivery_option,status`).then((response) => {
        this.campaign = response.data;
        if (this.campaign.channel !== 'bot') {
          this.axios.get(`/templates?paginate=0&notNull=${this.campaign.channel}&diff=template_code&diff-value=000`).then((resp) => {
            this.campaign.template_id ? this.template = resp.data.find(o => o.id === this.campaign.template_id) : this.template = resp.data[0];
            this.templates = resp.data;
          });
        } else {
          this.axios.get(`/bot_templates?fields=name,status,id,botTemplateDetails.name,botTemplateDetails.text&paginate=0`).then((resp) => {
            this.campaign.template_id ? this.template = resp.data.find(o => o.id === this.campaign.template_id) : this.template = resp.data[0];
            this.templates = resp.data;
          });
        }
        //this.campaignSmyAndVar();
      }).catch(() => { });
    },
    confirmDeliveryOption() {
      if (this.form.delivery_option === 'Agendada') {
        const data = {
          name: this.form.name,
          template_id: this.template.id,
          delivery_option: this.form.delivery_option,
          start_date: this.form.start_date ? this.form.start_date : '',
          start_hour: this.form.start_hour ? moment(`${this.form.start_date} ${this.form.start_hour}:00`).local().utc().format('HH:mm') : '',
          status_of_customers: this.selectedStatusOfCustomers,
          status_of_notifications: this.selectedStatusOfNotificationSchedules,
          status: 'Programada',
        };
        this.axios.post(`/campaigns/${this.$route.params.campaign}/resend`, data).then(() => {
          this.$router.push('/campaigns');
        }).catch((e) => {
          EventBus.$emit('modal', e.response.data);
        });
      } else {
        const data = {
          name: this.form.name,
          template_id: this.template.id,
          delivery_option: this.form.delivery_option,
          status_of_customers: this.selectedStatusOfCustomers,
          status_of_notifications: this.selectedStatusOfNotificationSchedules,
          status: 'Programada',
        };
        this.axios.post(`/campaigns/${this.$route.params.campaign}/resend`, data).then(() => {
          this.$router.push('/campaigns');
        }).catch((e) => {
          EventBus.$emit('modal', e.response.data);
        });
      }
    },
    formatDate(date, typeDate, toFormat) { // eslint-disable-line
      return moment(date, typeDate).format(toFormat);
    },
    searchTemplates() {
      if (this.campaign.channel !== 'bot') {
        this.text = this.template[this.campaign.channel === 'email' ? 'text' : this.campaign.channel];
      }
      this.e1 = this.e1 += 1;
    },
    updateTemplate(channel, template) {
      this.axios.patch(`/templates/${template.id}`, {
        [channel === 'email' ? 'text' : channel]:template[channel === 'email' ? 'text' : channel],
      }).then(() => {
        this.e1 = this.e1 += 1;
      }).catch(() => { });
    },
    /* eslint-enable */
  },
  watch: {
    template(val) {
      if (val) {
        this.form.template_id = val.id;
        if (this.campaign.channel !== 'bot') {
          this.text = val[this.campaign.channel === 'email' ? 'text' : this.campaign.channel];
        }
      }
    },
    form: {
      handler(val) {
        this.campaign.delivery_option = val.delivery_option;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.awesomplete.campaign {
  width: 97% !important;
}

.custom-error {
  position: relative;
  top: 170px;
}

.card__actions.custom-actions {
  position: relative;
  top: 170px;
}

.confirm-campaign--scrollbar > div {
  height:280px !important;
}

.accordion-content {
  height:auto;
}
.accordion-content .content {
  display:none;
  position: relative;
  transition-property:display;
  transition-duration: 5s !important;
}
.accordion-content .content.open {
  display:flex;
  -webkit-animation-name: open; /* Safari 4.0 - 8.0 */
  -webkit-animation-duration: 0.3s; /* Safari 4.0 - 8.0 */
  animation-name: open;
  animation-duration: 0.3s;
}
.accordion-content .content.close {
  -webkit-animation-name: close; /* Safari 4.0 - 8.0 */
  -webkit-animation-duration: 0.3s; /* Safari 4.0 - 8.0 */
  animation-name: close;
  animation-duration: 0.3s;
  display:none;
}

.animate-first-pointer {
  animation: firstPointer 1s linear infinite;
}

.animate-second-pointer {
  animation: secondPointer 2s linear infinite;
}

.animate-third-pointer {
  animation: thirdPointer 3s linear infinite;
}

.vertical-divider-template-50 {
  height: 50px !important;
  width: 50% !important;
  border-left-color: rgba(0, 0, 0, 0.4) !important;
  border-left-width: 1px !important;
  border-top-width: 2px !important;
  margin-left: 25% !important;
}

.vertical-divider-template-100 {
  height: 160px !important;
  width: 50% !important;
  border-left-color: rgba(0, 0, 0, 0.4) !important;
  border-left-width: 1px !important;
  margin-left: 25% !important;
}

.vertical-divider {
  height: 100px !important;
  width: 50% !important;
  border-left-color: rgba(0, 0, 0, 0.4) !important;
  border-left-width: 2px !important;
  margin-left: 50% !important;
}

@-webkit-keyframes firstPointer {
  50% {
    opacity: 0;
  }
}

@keyframes firstPointer {
  50% {
    opacity: 0;
  }
}

@-webkit-keyframes secondPointer {
  50% {
    opacity: 0;
  }
}

@keyframes secondPointer {
  50% {
    opacity: 0;
  }
}

@-webkit-keyframes thirdPointer {
  50% {
    opacity: 0;
  }
}

@keyframes thirdPointer {
  50% {
    opacity: 0;
  }
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes close {
  from {opacity:1;}
  to {opacity:0;}
}

/* Standard syntax */
@keyframes close {
  from {opacity:1;}
  to {opacity:0;}
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes open {
  from {opacity:0;}
  to {opacity:1;}
}

/* Standard syntax */
@keyframes open {
  from {opacity:0;}
  to {opacity:1;}
}
</style>



// WEBPACK FOOTER //
// src/components/campaign/CampaignResend.vue